import { render, staticRenderFns } from "./LogMessage.vue?vue&type=template&id=5cb067dd"
import script from "./LogMessage.vue?vue&type=script&lang=js"
export * from "./LogMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports